
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"128","height":"128","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"id-47a","width":"142.4%","height":"142.4%","x":"-21.2%","y":"-15.2%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"4","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"4"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0.388235294 0 0 0 0 0.517647059 0 0 0 0.1 0"}})]),_c('path',{attrs:{"id":"id-48b","d":"M63.786 31L97 61h-7v36H39V61h-8l32.786-30z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"64","cy":"64","r":"64","fill":"#FFE4B1"}}),_c('use',{attrs:{"fill":"#000","filter":"url(#id-47a)","xlink:href":"#id-48b"}}),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#id-48b"}}),_c('g',{attrs:{"transform":"translate(65 75.5)"}},[_c('circle',{attrs:{"cx":"16","cy":"16.5","r":"16","fill":"#E1312A"}}),_c('path',{attrs:{"fill":"#FFF","d":"M21.657 10.343a1 1 0 010 1.414L17.415 16l4.242 4.243a1 1 0 11-1.415 1.415L16 17.414l-4.243 4.243a1 1 0 01-1.414-1.415L14.586 16l-4.243-4.243a1 1 0 111.414-1.414L16 14.586l4.242-4.243a1 1 0 011.415 0z"}})])])])
          )
        }
      }
    